import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Table from "react-bootstrap/Table";
import Badge from "react-bootstrap/Badge";
import TicketRequest from "../../magData/Hotel/TicketRequest";
import TicketResponse from "../../magData/Hotel/TicketResponse";

function HotelTicketPage(props) {
  return (
    <>
      <Container fluid>
        <Row>
          <Col sm={12}>
            <p className="page-title">Hotel Ticket Method</p>
          </Col>
          <Col sm={12}>
            <p>EndPoint : https://gdscpapi.parsgds.com/gateway/Hotel/ticket</p>
          </Col>
          <Col sm={12}>
            <p> type : json (default)</p>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <p>Body Parameters</p>
          </Col>
          <Col sm={12}>
            <Table striped bordered>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Additional information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={4}>
                    <Table bordered>
                      <tbody>
                        <tr>
                          <td>gdsRefrenceID</td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      </tbody>
                    </Table>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <span className="code-section-title">
              Request Formats - application/json, text/json
            </span>
          </Col>
          <Col sm={12}>
            <pre className="code-section">
              {JSON.stringify(TicketRequest, null, 2)}
            </pre>
          </Col>
        </Row>

        {/* Response  */}
        <Row>
          <Col sm={12}>
            <p>Response Information</p>
          </Col>
          <Col sm={12}>
            <Table striped bordered>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Additional information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>bookedBy</td>
                  <td>bookedBy</td>
                  <td>string</td>
                  <td>
                    <Badge bg="warning" text="dark">
                      None.
                    </Badge>
                  </td>
                </tr>
                <tr>
                  <td>orderBy</td>
                  <td>orderBy</td>
                  <td>string</td>
                  <td>
                    <Badge bg="warning" text="dark">
                      None.
                    </Badge>
                  </td>
                </tr>
                <tr>
                  <td>clientBalance</td>
                  <td>clientBalance</td>
                  <td>integer</td>
                  <td>
                    <Badge bg="warning" text="dark">
                      None.
                    </Badge>
                  </td>
                </tr>
                <tr>
                  <td>PaymentDeadline</td>
                  <td>
                    <p>Payment Deadline</p>
                  </td>
                  <td>date</td>
                  <td>
                    <Badge bg="warning" text="dark">
                      None.
                    </Badge>
                  </td>
                </tr>
                <tr>
                  <td>vatNumber</td>
                  <td>
                    <p>vatNumber</p>
                  </td>
                  <td>string</td>
                  <td>
                    <Badge bg="warning" text="dark">
                      None.
                    </Badge>
                  </td>
                </tr>
                <tr>
                  <td>supplierName</td>
                  <td>
                    <p>supplierName</p>
                  </td>
                  <td>string</td>
                  <td>
                    <Badge bg="warning" text="dark">
                      None.
                    </Badge>
                  </td>
                </tr>
                <tr>
                  <td>totalNetRate</td>
                  <td>
                    <p>totalNetRate</p>
                  </td>
                  <td>integer</td>
                  <td>
                    <Badge bg="warning" text="dark">
                      None.
                    </Badge>
                  </td>
                </tr>
                <tr>
                  <td>Currency</td>
                  <td>
                    <p>Currency</p>
                  </td>
                  <td>string</td>
                  <td>
                    <Badge bg="warning" text="dark">
                      None.
                    </Badge>
                  </td>
                </tr>
                <tr>
                  <td>CheckIn</td>
                  <td>Check In Date</td>
                  <td>date</td>
                  <td>
                    <Badge bg="warning" text="dark">
                      Required
                    </Badge>
                  </td>
                </tr>
                <tr>
                  <td>CheckOut</td>
                  <td>Check Out Date</td>
                  <td>date</td>
                  <td>
                    <Badge bg="warning" text="dark">
                      Required
                    </Badge>
                  </td>
                </tr>
                <tr>
                  <td>Rooms</td>
                  <td>
                    <p>Rooms</p>
                  </td>
                  <td>Object</td>
                  <td>
                    <Badge bg="warning" text="dark">
                      None.
                    </Badge>
                  </td>
                </tr>
                <tr>
                  <td colSpan={4}>
                    <Table bordered>
                      <tbody>
                        <tr>
                          <td>Name</td>
                          <td>Name</td>
                          <td>string</td>
                          <Badge bg="warning" text="dark">
                            None.
                          </Badge>
                        </tr>
                        <tr>
                          <td>MealType</td>
                          <td>
                            <p>Meal Type</p>
                          </td>
                          <td>string</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>SharingBedding</td>
                          <td>
                            <p>Sharing Bedding</p>
                          </td>
                          <td>boolean</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>BedGroups</td>
                          <td>
                            <p>Bed Groups</p>
                          </td>
                          <td>string</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>passengers</td>
                          <td>
                            <p>passengers</p>
                          </td>
                          <td>Object</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={4}>
                            <Table bordered>
                              <tbody>
                                <tr>
                                  <td>firstName</td>
                                  <td>firstName</td>
                                  <td>string</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>lastName</td>
                                  <td>lastName</td>
                                  <td>string</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>passengerType</td>
                                  <td>passengerType</td>
                                  <td>integer</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>passengerGender</td>
                                  <td>passengerGender</td>
                                  <td>integer</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>childAge</td>
                                  <td>childAge</td>
                                  <td>integer</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>nationalID</td>
                                  <td>nationalID</td>
                                  <td>string</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>passportNumber</td>
                                  <td>passportNumber</td>
                                  <td>string</td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </td>
                </tr>
                <tr>
                  <td>Amenities</td>
                  <td>
                    <p>Amenities</p>
                  </td>
                  <td>Collection of string</td>
                  <td>
                    <Badge bg="warning" text="dark">
                      None.
                    </Badge>
                  </td>
                </tr>
                <tr>
                  <td>hotelConfirmationNo</td>
                  <td>hotelConfirmationNo</td>
                  <td>String</td>
                  <td>
                    <Badge bg="warning" text="dark">
                      None.
                    </Badge>
                  </td>
                </tr>
                <tr>
                  <td>Remarks</td>
                  <td>Remarks</td>
                  <td>Collection of string</td>
                  <td>
                    <Badge bg="warning" text="dark">
                      None.
                    </Badge>
                  </td>
                </tr>
                <tr>
                  <td>gdsRefrenceID</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <span className="code-section-title">
              Response Formats - application/json, text/json
            </span>
          </Col>
          <Col sm={12}>
            <pre className="code-section">
              {JSON.stringify(TicketResponse, null, 2)}
            </pre>
          </Col>
        </Row>
      </Container>
    </>
  );
}
export default HotelTicketPage;
